export const TRACKING_DELAY = 800

export const ANALYTICS_WAIT_TIME = 800
